import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M2.708 6.667a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25m2.084 1.25a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M10 1.666V2.5a1.67 1.67 0 0 1-1.667 1.667H7.144l-1.014.706a.72.72 0 0 1-.748.04A.72.72 0 0 1 5 4.278V1.666c0-.92.747-1.667 1.667-1.667h1.666c.92 0 1.667.748 1.667 1.667m-.833 0a.834.834 0 0 0-.834-.834H6.667a.834.834 0 0 0-.834.834v2.398l.943-.656a.4.4 0 0 1 .238-.075h1.32a.834.834 0 0 0 .833-.833zM6.875 6.25h-.208a.417.417 0 1 0-.834 0v2.083c0 .46-.373.834-.833.834H2.5a.834.834 0 0 1-.833-.834V6.25c0-.46.373-.833.833-.833h1.25c.23 0 .417-.187.417-.417v-.833a.417.417 0 0 0-.834 0v.416H2.5c-.92 0-1.667.748-1.667 1.667H.625A.626.626 0 0 0 0 6.875v.833c0 .345.28.625.625.625h.208C.833 9.253 1.581 10 2.5 10H5c.92 0 1.667-.748 1.667-1.667h.208c.345 0 .625-.28.625-.625v-.833a.626.626 0 0 0-.625-.625"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h10v10H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }